enum UserStatus {
    INVITED,
    EXPIRED,
    ACTIVATED,
}

export default UserStatus;
